import { render, staticRenderFns } from "./viewshow.vue?vue&type=template&id=715d21c4&"
import script from "./viewshow.vue?vue&type=script&lang=js&"
export * from "./viewshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports